(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.m-section-header');
      this.megamenu = document.querySelector('mega-menu');
      this.navBar = this.querySelector('.m-header__nav');
      this.headerTop = this.querySelector('.m-header__top-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerMenuIcon = this.querySelector('.m-header-menu-icon');
      this.headerBounds = {};
      this.headerTop = this.querySelector('.m-header__top-wrapper');

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('m-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.headerMenuIcon.addEventListener('click', this.toggleMenuBar.bind(this));

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    toggleMenuBar() {
      if (this.headerMenuIcon.classList.contains('is-open')) {
        this.headerMenuIcon.classList.remove('is-open');
      } else {
        this.headerMenuIcon.classList.add('is-open');
      }
      if (this.navBar.classList.contains('nav-bar-hidden')) {
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
      } else {
        this.navBar.classList.add('nav-bar-hidden');
        this.headerTop.classList.add('nav-bar-hidden');
      }
    }

    setHeaderTopHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerTop.offsetHeight}px`);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--nav-bar-height', `${this.navBar.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.documentElement.classList.add('scrolled-past-header');
        this.setHeaderTopHeight();
        if (!this.headerMenuIcon.classList.contains('is-open')) {
          this.navBar.classList.add('nav-bar-hidden');
          this.headerTop.classList.add('nav-bar-hidden');
        }
        this.megamenu && this.megamenu.init();
        this.megamenu && this.megamenu.close();
        this.headerIsAlwaysSticky && this.megamenu && this.megamenu.setAttribute('data-toggle', 'true');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.documentElement.classList.remove('scrolled-past-header');
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
        this.headerMenuIcon.classList.remove('is-open');
        this.setHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.removeAttribute('data-toggle');
      this.header.classList.add('m-section-header-hidden', 'm-section-header-sticky');
      document.documentElement.classList.add('m-section-header-hidden');
      this.closeLocalizationForm();
      this.closePredictiveSearch();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.setAttribute('data-toggle', 'true');
      this.header.classList.add('m-section-header-sticky', 'animate');
      this.header.classList.remove('m-section-header-hidden');
      document.documentElement.classList.remove('m-section-header-hidden');
    }

    reset() {
      if (this.megamenu && this.megamenu.openDefault && this.megamenu.template === 'index') {
        this.megamenu && this.megamenu.open();
      }
      if (this.currentScrollTop === 0) {
        this.megamenu && this.megamenu.removeAttribute('data-toggle');
      }
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('m-section-header-hidden', 'm-section-header-sticky', 'animate');
    }

    closePredictiveSearch() {
      this.predictiveSearch = this.predictiveSearch || this.header.querySelector('predictive-search');
      this.predictiveSearch.close(false);
    }

    closeLocalizationForm() {
      this.localization = this.localization || this.header.querySelectorAll('localization-form');
      this.localization.forEach((localization) => localization.hidePanel());
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saudi-national-day-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cleanups = new WeakMap();
  const initialize = (root) => {
    if (!root || cleanups.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const observers = [];
    const refreshers = new Map();
    root.querySelectorAll('.midi-nd-track').forEach((feed, index) => {
      feed.tabIndex = 0;
      feed.id = 'nd-track-' + root.dataset.sectionId + '-' + index;
      const pagination = feed.parentElement.querySelector('[data-nd-pagination]');
      if (pagination) feed.appendChild(pagination);
      const wrapper = document.createElement('div');
      wrapper.className = 'midi-nd-carousel';
      feed.before(wrapper);
      wrapper.appendChild(feed);
      const label = feed.getAttribute('aria-label') || '';
      const makeArrow = (direction, text, accessible) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'midi-nd-carousel__arrow midi-nd-carousel__arrow--' + direction;
        button.textContent = text;
        button.setAttribute('aria-label', accessible + ' — ' + label);
        button.setAttribute('aria-controls', feed.id);
        wrapper.appendChild(button);
        return button;
      };
      const previous = makeArrow('previous', '›', root.dataset.prevLabel);
      const next = makeArrow('next', '‹', root.dataset.nextLabel);
      const update = () => {
        const distance = Math.abs(feed.scrollLeft);
        const maximum = Math.max(0, feed.scrollWidth - feed.clientWidth);
        previous.disabled = distance <= 2;
        next.disabled = distance >= maximum - 2;
      };
      const move = (step) => {
        const rtl = getComputedStyle(feed).direction === 'rtl';
        feed.scrollBy({left: step * (rtl ? -1 : 1) * feed.clientWidth, behavior});
      };
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      feed.addEventListener('scroll', update, {passive:true, signal});
      feed.addEventListener('keydown', (event) => {
        if (event.target !== feed || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? 1 : -1);
      }, {signal});
      const resize = new ResizeObserver(update);
      resize.observe(feed);
      observers.push(resize);
      refreshers.set(feed, update);
      update();
    });
    const navLinks = [...root.querySelectorAll('.midi-nd-nav a[href^="#"]')];
    const sections = [...root.querySelectorAll('.midi-nd-section')];
    const setActive = (id) => navLinks.forEach(link => {
      if (link.getAttribute('href') === '#' + id) link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    });
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const current = sections.filter(s => s.getBoundingClientRect().top <= 180).sort((a,b) => b.getBoundingClientRect().top - a.getBoundingClientRect().top)[0];
        if (current) setActive(current.id);
      });
    };
    window.addEventListener('scroll', onScroll, {passive:true,signal});
    root.addEventListener('click', async (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (anchor && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
        const target = root.querySelector(anchor.getAttribute('href'));
        if (target) {
          event.preventDefault();
          target.scrollIntoView({behavior,block:'start'});
          history.replaceState(null,'',anchor.getAttribute('href'));
          setActive(target.id);
        }
        return;
      }
      const button = event.target.closest('[data-nd-load-more]');
      if (!button || button.disabled || !root.contains(button)) return;
      const key = button.dataset.ndLoadMore;
      const feed = root.querySelector('[data-nd-feed="' + key + '"]');
      const pagination = button.closest('[data-nd-pagination]');
      if (!feed || !pagination || !button.dataset.nextUrl) return;
      const originalLabel = button.textContent;
      pagination.querySelector('[role="status"]')?.remove();
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      button.textContent = root.dataset.loadingLabel;
      try {
        const url = new URL(button.dataset.nextUrl,window.location.origin);
        url.searchParams.set('section_id',root.dataset.sectionId);
        const response = await fetch(url.toString(),{signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
        if (!response.ok) throw new Error('Request failed');
        const nextDocument = new DOMParser().parseFromString(await response.text(),'text/html');
        const nextFeed = nextDocument.querySelector('[data-nd-feed="' + key + '"]');
        if (!nextFeed) throw new Error('Feed not found');
        const known = new Set([...feed.querySelectorAll('.midi-nd-card__image')].map(a=>a.getAttribute('href')));
        let firstAdded;
        [...nextFeed.querySelectorAll('.midi-nd-card')].forEach(card => {
          const href = card.querySelector('.midi-nd-card__image')?.getAttribute('href');
          if (!href || known.has(href)) return;
          known.add(href);
          const copy = card.cloneNode(true);
          feed.insertBefore(copy,pagination);
          firstAdded ||= copy;
        });
        const nextPagination = nextDocument.querySelector('[data-nd-pagination="' + key + '"]');
        if (nextPagination) pagination.replaceWith(nextPagination);
        else pagination.remove();
        refreshers.get(feed)?.();
        if (firstAdded) {
          firstAdded.querySelector('a')?.focus({preventScroll:true});
          firstAdded.scrollIntoView({behavior,block:'nearest',inline:'start'});
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;
        const status = document.createElement('span');
        status.className = 'midi-nd-status';
        status.setAttribute('role','status');
        status.textContent = root.dataset.errorLabel;
        pagination.appendChild(status);
      }
    }, {signal});
    cleanups.set(root, () => {
      controller.abort();
      observers.forEach(observer=>observer.disconnect());
      cancelAnimationFrame(frame);
      cleanups.delete(root);
    });
  };
  document.querySelectorAll('.midi-nd[data-section-id]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>initialize(event.target.querySelector('.midi-nd')));
  document.addEventListener('shopify:section:unload',event=>{
    const root=event.target.querySelector('.midi-nd');
    cleanups.get(root)?.();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
